/**
 * The share-referral modal, as an ad descriptor's `modal` field.
 *
 * Every surface that offers the referral ask opens the SAME modal with the same
 * words — so the words live here once rather than being copied into each
 * registry, where they would drift apart the first time one of them was edited.
 *
 * `trackingPrefix` and `inviteSource` are what a caller MUST supply and must not
 * share. The modal builds its three event names from the prefix, so two surfaces
 * passing the same one would fold their sends into a single funnel; `inviteSource`
 * is the same question asked of the invite email's `ref_src`, and answered on the
 * signup rather than on the send.
 *
 * `bonusProgramKey` is deliberately absent: omitting it suppresses the swag
 * footnote and, in its place, keeps the "See your rewards" link to /referral
 * (ShareReferralModal.jsx:321). A caller that names a bonus campaign gets the
 * footnote's "Track your credit" instead — one route to /referral per surface,
 * never both.
 */
const SHARED_PROPS = {
  ariaLabel: 'Share Diffit with other teachers',
  headline: 'Share Diffit, Get Rewards',
  // No subhead: the modal shows the invite program's `copy.modal_subhead`, so the terms follow its config.
};

export const shareReferralModal = ({ inviteProgramKey, inviteSource, trackingPrefix }) => ({
  // Named by key rather than holding the component: that keeps a registry plain
  // data, so reading an ad id cannot pull Clerk's module-scope init into the
  // import graph. PromoAd and SidebarAdCard each resolve the key.
  key: 'shareReferral',
  props: { ...SHARED_PROPS, inviteProgramKey, inviteSource, trackingPrefix },
});
